import {Pipe, PipeTransform} from "@angular/core";
import {Audit, AuditType} from "../../store/state/order.state";

@Pipe({
    name: 'auditEvent',
    standalone: false
})
export class AuditEventPipe implements PipeTransform {

	transform(audit: Audit, displayFollowingAuditEvent: boolean = false): string {
		return audit.products.map(product => {
			if ([AuditType.PRE_AUDIT, AuditType.STAGE_1, AuditType.STAGE_2, AuditType.INITIAL_CERTIFICATION].includes(displayFollowingAuditEvent ? product.followingAuditEvent : product.currentAuditEvent)) {
				return "Initial Certification";
			} else {
				switch (displayFollowingAuditEvent ? product.followingAuditEvent : product.currentAuditEvent) {
					case AuditType.SURVEILLANCE_1:
						return "Surveillance 1";
					case AuditType.SURVEILLANCE_2:
						return "Surveillance 2";
					case AuditType.RECERTIFICATION:
						return "Recertification";
					default:
						return "";
				}
			}
		}).join(', ');
	}
}
